"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var defaultProps = {
    // Core props
    disabled: false,
    isAnswered: false,
    isSafari: false,
    isAutoFilledActive: false,
    enableCountryChange: true,
    enableCountrySearch: false,
    useModalForCountrySelection: false,
    type: 'tel',
    id: '',
    label: '',
    value: '',
    placeholder: '',
    errorMessage: undefined,
    initialCountry: undefined,
    // Input filtering settings
    strictMode: false,
    // Country selection customization
    countrySearchPlaceholder: 'Search countries...',
    countryModalHeading: 'Select Country',
    preferredCountries: ['US', 'GB'], // Default to US and GB for backward compatibility
    // Specific callbacks
    onPhoneNumberChange: undefined,
    onCountryChange: undefined,
    onValidationChange: undefined,
    onFormattedValueChange: undefined,
    // Legacy callback for backward compatibility
    onChange: function () {
        // action
    },
    // Event handlers
    onClick: function () {
        // action
    },
    onBlur: function () {
        // action
    },
};
exports.default = defaultProps;
//# sourceMappingURL=defaultProps.js.map